module.exports = __webpack_public_path__ + "static/img/thresholdvalue.572b4c7c.png";